<template>
	<el-dialog title="退款" width="550px" v-model="data.dialogTableVisible">
		<el-form label-width="100px">
			<el-form-item label="姓名:">
				{{ currentData.userName }}
			</el-form-item>
			<el-form-item label="支持退款金额:">
				{{ (currentData.amount - currentData.giftAmount - currentData.tkAmount) }}
			</el-form-item>
			<el-form-item label="退款金额:" required>
				<el-input
					v-model="data.refundAmount"
					placeholder="请输入退款金额"
				></el-input>
			</el-form-item>
			<el-form-item label="退款原因:" required>
				<el-input
					type="textarea"
					:autosize="{ minRows: 2 }"
					placeholder="请输入退款原因"
					v-model="data.userTypeRefuseReason"
				>
				</el-input>
			</el-form-item>
		</el-form>
		<footer class="tac" style="margin-top: 50px">
			<el-button @click="handleToggle(false)">取消</el-button>
			<el-button type="primary" @click="handleRefund">确认退款</el-button>
		</footer>
	</el-dialog>
</template>


<script>
import { defineComponent, inject, reactive } from "vue";
import { ElMessage } from "element-plus";
import { consumptionRefund } from '@/api/requestApis.js'; // 引入退款接口

export default defineComponent({
    props: {
        currentData: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    setup(props) {
        const handleUpdateTable = inject("handleUpdateTable");
        const data = reactive({
            dialogTableVisible: false,
            userTypeRefuseReason: "",
            refundAmount: "",
        });

        const handleReset = () => {
            data.userTypeRefuseReason = "";
            data.refundAmount = "";
        };

        const handleToggle = (val) => {
            data.dialogTableVisible = val;
        };

        // 修改退款处理方法，使用 consumptionRefund 接口
        const handleRefund = async () => {
            if (!data.refundAmount) {
                ElMessage.warning("请输入退款金额");
                return;
            }

            if (isNaN(data.refundAmount) || parseFloat(data.refundAmount) <= 0) {
                ElMessage.warning("请输入有效的退款金额");
                return;
            }

            if (!data.userTypeRefuseReason) {
                ElMessage.warning("请输入退款原因");
                return;
            }

            try {
                // 使用 consumptionRefund 替代直接 axios 调用
                await consumptionRefund({
                    recordId: props.currentData.id,
                    refundAmount: parseFloat(data.refundAmount)
                });

                // 如果没有抛出异常，说明退款成功
                ElMessage.success("退款成功");
                handleToggle(false);
                handleReset();
                handleUpdateTable();
            } catch (error) {
                // 错误信息已经在 consumptionRefund 中处理过了
                console.error("退款请求失败:", error);
            }
        };

        return {
            handleRefund,
            handleToggle,
            data,
        };
    },
});
</script>



<style scoped>
.imgBox {
	width: 150px;
	height: 100px;
}
</style>
